const PendingRevies = () => import(/* webpackChunkName: "PendingRevies" */ '@/views/PendingRevies')
const Detail = () => import(/* webpackChunkName: "PendingReviesDetail" */ '@/views/PendingRevies/detail')
const pendingReviesRouter = [
  {
    path: '/pendingRevies',
    component: PendingRevies,
    meta: {
      title: 'Pending Revies'
    }
  },
  {
    path: '/pendingRevies/detail',
    component: Detail,
    meta: {
      title: 'Review Detail'
    }
  }
]

export default pendingReviesRouter
